export default {
  loading: {
    id: 'bo_seller-homepage-loading',
    defaultMessage: 'Loading...',
  },
  saleInsights: {
    id: 'bo_seller-homepage-sale_insights',
    defaultMessage: 'Sale insights',
  },
  lastSevenDays: {
    id: 'bo_seller-homepage-sale_insights-last_seven_days',
    defaultMessage: 'Last 7 days',
  },
  viewDetails: {
    id: 'bo_seller-homepage-sale_insights-view_details',
    defaultMessage: 'View details',
  },
  salesMetricsOrderBlockTitle: {
    id: 'merchant_home_page_sales_metrics_order_block_title',
    defaultMessage: 'Orders received',
  },
  salesMetricsSalesRevenueBlockTitle: {
    id: 'merchant_home_page_sales_metrics_sales_revenue_block_title',
    defaultMessage: 'Sales revenue from shipped orders (shipping incl.)',
  },
  salesMetricsTotalRefundBlockTitle: {
    id: 'merchant_home_page_sales_metrics_total_refund_block_title',
    defaultMessage: 'Total refunds (shipping incl.)',
  },
  noOrders: {
    id: 'merchant_home_page_sales_metrics_no_orders',
    defaultMessage: 'No orders yet.',
  },
  noSalesRevenue: {
    id: 'merchant_home_page_sales_metrics_no_sales_revenue',
    defaultMessage: 'No sales revenue yet.',
  },
  noRefunds: {
    id: 'merchant_home_page_sales_metrics_no_refunds',
    defaultMessage: 'No refunds yet.',
  },
  noDataForSelectedPeriod: {
    id: 'bo_seller.homepage.sales_metrics.no_data_for_selected_period',
    defaultMessage:
      'There is no data for the selected time period. Try a different time period, or get started with selling on Backmarket.',
  },
  saleInsightsTimePeriod: {
    id: 'bo_seller.homepage.sale_metrics.time_period_label',
    defaultMessage: 'Time period',
  },
}
